import React, {ChangeEventHandler, PropsWithChildren} from 'react';
import styled from 'styled-components';
import {Toggle} from '../Toggle/Toggle';

export const ToggleButton = ({
  children,
  onToggleClicked,
  checked,
  disabled,
  ...props
}: PropsWithChildren<{
  onToggleClicked: ChangeEventHandler;
  checked: boolean;
  disabled?: boolean;
  ['data-testid']?: string;
  ['aria-label']: string;
}>) => {
  return (
    <ToggleWrapper data-testid={props['data-testid']}>
      <ToggleLabel>{children}</ToggleLabel>
      <StyledToggle
        checked={checked}
        onChange={onToggleClicked}
        disabled={disabled}
        aria-label={props['aria-label']}
      />
    </ToggleWrapper>
  );
};

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ToggleLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
`;

const StyledToggle = styled(Toggle)`
  &:after {
    width: 24px;
    height: 24px;
  }

  & input {
    height: 1rem;
    width: 40px;
  }

  height: 1rem;
  width: 40px;
`;
